module.exports = __webpack_public_path__ + "img/media_3.de965eca.jpg";